// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-data-icon[data-v-ee20fee2]{margin-top:80px}.copy[data-v-ee20fee2]{width:226px}.v-expansion-panels .v-expansion-panel[data-v-ee20fee2]:not(:first-child)::after{border-color:#fff}", ""]);
// Exports
module.exports = exports;
